import { render } from "./MmResetPassword.vue?vue&type=template&id=626b5e28"
import script from "./MmResetPassword.vue?vue&type=script&lang=js"
export * from "./MmResetPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__